var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79288 10.297L12.5 16.0041L18.2071 10.2969L16.7929 8.88274L13.5 12.1756L13.5 3H11.5L11.5 12.1756L8.20709 8.88274L6.79288 10.297Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41 18.12L2.5 15H4.58333L5.33 17.56C5.57889 18.4134 6.36111 19 7.25 19H17.75C18.6389 19 19.4211 18.4134 19.67 17.56L20.4167 15H22.5L21.59 18.12C21.0922 19.8267 19.5278 21 17.75 21H7.25C5.47222 21 3.90778 19.8267 3.41 18.12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.be8062bf32ef24386bb0f045438eecfd.svg";
export { ForwardRef as ReactComponent };